import { createElement } from 'react';
import cn from 'classnames';
import styles from './Toolbar.module.scss';

const Toolbar = ({
  className,
  isHeader = false,
  background = 'dark',
  ...props
}) =>
  createElement(isHeader ? 'header' : 'div', {
    ...props,
    className: cn(styles.root, className, {
      [styles.lightBg]: background === 'light',
      [styles.darkBg]: background === 'dark',
    }),
  });

export default Toolbar;
